class Vector{
    constructor(x, y) {
        this.setVector(x, y);
    }

    setVector(x, y) {
        this.x = x;
        this.y = y;
    }
}

export default Vector;